import { useI18n } from 'vue-i18n';
import AuthController from '@/controllers/AuthController';
import NavigationHelper from '@/util/NavigationHelper';
import { useRouter } from 'vue-router';
import { Forms } from '@/enums/Forms';
import ValidationRules from '@/util/ValidationRules';
import { Ref, ref } from 'vue';
import PageHelper from '@/util/PageHelper';
import PolteqButton from '@/components/PolteqButton/PolteqButton.vue';
import PolteqTextField from '@/components/PolteqTextField/PolteqTextField.vue';
import { VForm } from 'vuetify/components';
import { AuthResponseStatus } from '@/enums/AuthResponseStatus';

export default {
  name: 'ActivateForm',
  components: {
    PolteqButton,
    PolteqTextField
  },
  computed: {
    NavigationHelper() {
      return NavigationHelper;
    }
  },
  setup() {
    const i18n = useI18n();
    const router = useRouter();
    const location = window.location.search;
    const activationQueryParam = new URLSearchParams(location).get('activationCode');
    const activationCode = ref(activationQueryParam ? activationQueryParam : '');
    const rules = ValidationRules.getRules();
    const activateForm = ref() as Ref<VForm>;
    const activate = async (username: string, password: string) => {
      await activateForm.value.validate();
      if (activateForm.value.isValid) {
        const response = await AuthController.activate(username, password, activationCode.value);
        if (response.status === AuthResponseStatus.FAILED) {
          PageHelper.setNotificationMessage(response);
        } else {
          await NavigationHelper.openForm(router, Forms.SIGN_IN, { code: response.accessToken });
        }
      }
    };
    return {
      i18n,
      router,
      Forms,
      activationCode,
      rules,
      activateForm,
      activate
    };
  },
  data() {
    return {
      username: '',
      password: ''
    };
  }
};
